import axios from './../api.js'
import Vue from 'vue'

const state = {
    selectedTask: {name: null, logs: [], activities: [], requisitions: [], requests: []},
    tempTask: null,
    selectedTemplate: {name: null, activities: []},
    activeTaskId: '',
    firmsForActivities: [],
    usersInFirmForActivity: [],
    contactsInFirmForActivity: [],
    selectedActivities: [],
    selectedRequisitions: [],
    isTemplate: null,
    taskTemplateList: {},
    enquiryAddressToTask: {},
    taskDocuments: [],
    taskDocumentsFromEnquiry: [],
    taskRequisitionDocuments: [],
    wfsObjects: [],
    requestOnTaskList: [],
    // When an activity is removed, we have to store the id so we can delete it later
    removeActivities: [],
    activitySaved: true
}

const getters = {
    getRequestOnTaskList: state => {
        return state.requestOnTaskList
    },
    getTaskRequest: state => {
        if (state.selectedTask.requests.length === 0) {
            return state.requestOnTaskList
        } else {
            return state.selectedTask.requests
        }
    },
    getEnquiryAddressToTask: state => {
        return state.enquiryAddressToTask
    },
    getSelectedTask: state => {
        return state.selectedTask
    },
    getSelectedTaskLogs: state => {
        return state.selectedTask.logs
    },
    getSelectedTemplate: state => {
        return state.selectedTemplate
    },
    activitiesAndObjectsList: state => {
        return state.selectedTask.activities
    },
    activitiesAndObjectsListTemplate: state => {
        return state.selectedTemplate.activities
    },
    getRequisitionsOnTaskList: state => {
        return state.selectedTask.requisitions
    },
    getActiveTaskId: state => {
        return state.activeTaskId
    },
    getAllFirmsForActivity: state => {
        return state.firmsForActivities.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1 }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1 }
            return 0
        })
    },
    getAllUsersInFirmForActivity: state => {
        return state.usersInFirmForActivity.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1 }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1 }
            return 0
        })
    },
    getSelectedActivities: state => {
        return state.selectedActivities
    },
    getSelectedRequisitions: state => {
        return state.selectedRequisitions
    },
    getTaskTemplate: state => {
        return state.isTemplate
    },
    getTaskTemplateList: state => {
        return state.taskTemplateList
    },
    getTaskDocuments: state => {
        return state.taskDocuments.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
    },
    getTaskRequisitionDocuments: state => {
        return state.taskRequisitionDocuments.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
    },
    getWfsObjects: state => {
        return state.wfsObjects
    },
    getActivitySaved: state => {
        return state.activitySaved
    },
    getTempTask: state => {
        return state.tempTask
    }
}

const mutations = {
    updateActivitiesStatus: (state, payload) => {
        payload.forEach(res => {
            state.selectedTask.activities.forEach(act => {
                if (res.data.requisitionId === act.requisitionId) {
                    act.reportApproveDate = res.data.approveDate
                }
            })
        })
    },
    addSelectedActivityObject: (state, payload) => {
        state.selectedActivities[payload.i].objectList.push(payload.obj)
    },
    addRequestOnTaskList: (state, payload) => {
        state.requestOnTaskList = payload
    },
    setRemoveRequestOnTaskListFromEnquiry: (state) => {
        state.requestOnTaskList = []
    },
    setEnquiryAddressToTask: (state, payload) => {
        state.enquiryAddressToTask = payload
    },
    addTaskObjects: (state, payload) => {
        if (payload.activities.length > 0) {
            payload.activities.forEach(a => {
                const activity = state.selectedActivities.find(activity => activity.activityId === a.activityId)
                if (activity) {
                    activity.objectList = a.objectList ? a.objectList : []
                    activity.allObjectsInActivityCount = a.allObjectsInActivityCount
                }
            })
        }
        if (payload.requisitions.length > 0) {
            payload.requisitions.forEach(req => {
                const selectedReq = state.selectedTask.requisitions.find(r => r.report.report.requisitionId === req.report.report.requisitionId)
                selectedReq.report = req.report
            })
        }
    },
    addWholeTaskItem: (state, payload) => {
        let task = {
            documents: [],
            logs: [],
            activities: [...state.selectedActivities.filter(act => act.activityId === '')],
            requisitions: [],
            requests: [],
            address1: payload.task.address1,
            address2: payload.task.address2,
            addressGuid: payload.task.addressGuid,
            businessAreaType: payload.task.businessAreaType,
            businessAreaTypeId: payload.task.businessAreaTypeId,
            city: payload.task.city,
            closedDate: payload.task.closedDate,
            created: payload.task.created,
            isTemplate: payload.task.isTemplate,
            locationPointWkt: payload.task.locationPointWkt,
            name: payload.task.name,
            objectState: payload.task.objectState,
            ownerActive: payload.task.ownerActive,
            ownerEmail: payload.task.ownerEmail,
            ownerName: payload.task.ownerName,
            ownerPhoneNumber: payload.task.ownerPhoneNumber,
            ownerUserId: payload.task.ownerUserId,
            postalCode: payload.task.postalCode,
            region: payload.task.region,
            requestClientResponse: payload.task.requestClientResponse,
            taskId: payload.task.taskId,
            taskVersionStamp: payload.task.taskVersionStamp,
            updated: payload.task.updated,
            allObjectsInActivityCount: payload.task.allObjectsInActivityCount
        }
        state.selectedTask = task
        if (payload.documents.length > 0) {
            if (state.taskDocuments.length > 0) {
                state.taskDocuments = []
            }
            payload.documents.forEach((file) => {
                if (file.contentType.startsWith('image/') && file.requestDocumentId) {
                    axios.downloadDocument('/TaskActivity/GetRequestThumbnail', {
                        RequestId: file.requestId,
                        RequestDocumentId: file.requestDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.taskDocuments.push({
                                id: file.requestDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                photoTaken: file.photoTaken,
                                description: file.description,
                                shared: file.shared,
                                origin: {
                                    name: 'enquiry',
                                    id: file.requestId
                                },
                                requestId: file.requestId,
                                requestDocumentId: file.requestDocumentId,
                                raw: file
                            })
                        })
                } else if (file.contentType.startsWith('image/') && file.taskDocumentId) {
                    axios.downloadDocument('/TaskActivity/GetTaskThumbnail', {
                        TaskId: payload.task.taskId,
                        TaskDocumentId: file.taskDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.taskDocuments.push({
                                id: file.taskDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                taskTemplateId: file.taskTemplateId,
                                photoTaken: file.photoTaken,
                                description: file.description,
                                origin: {
                                    name: 'task',
                                    id: payload.task.taskId
                                },
                                requestId: file.requestId,
                                requestDocumentId: file.requestDocumentId,
                                raw: file
                            })
                        })
                } else if (file.requestDocumentId) {
                    state.taskDocuments.push({
                        id: file.requestDocumentId,
                        dateCreated: file.created,
                        name: file.originalFileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        shared: file.shared,
                        origin: {
                            name: 'enquiry',
                            id: file.requestId
                        },
                        requestId: file.requestId,
                        requestDocumentId: file.requestDocumentId,
                        raw: file
                    })
                } else {
                    state.taskDocuments.push({
                        id: file.taskDocumentId,
                        dateCreated: file.created,
                        name: file.originalFileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        taskTemplateId: file.taskTemplateId,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        origin: {
                            name: 'task',
                            id: payload.task.taskId
                        },
                        requestId: file.requestId,
                        requestDocumentId: file.requestDocumentId,
                        raw: file
                    })
                }
            })
        }
        if (payload.activities.length > 0) {
            for (let k in payload.activities) {
                let activity = {
                    selected: false,
                    isAccordionOpen: false,
                    generatedActivityId: payload.activities[k].generatedActivityId,
                    activityId: payload.activities[k].activityId,
                    activityIdList: payload.activities[k].activityIdList,
                    activityType: payload.activities[k].activityType,
                    activityTypeId: payload.activities[k].activityTypeId,
                    activityVersionStamp: payload.activities[k].activityVersionStamp,
                    created: payload.activities[k].created,
                    description: payload.activities[k].description,
                    generateFromDate: payload.activities[k].generateFromDate,
                    highPriority: payload.activities[k].highPriority,
                    hyperlink: payload.activities[k].hyperlink,
                    isRoutineTemplate: payload.activities[k].isRoutineTemplate,
                    latestDate: payload.activities[k].latestDate,
                    numberOfDays: payload.activities[k].numberOfDays,
                    objectActivityVersionStamp: payload.activities[k].objectActivityVersionStamp,
                    objectIdStr: payload.activities[k].objectIdStr,
                    objectList: payload.activities[k].objectList,
                    objectState: payload.activities[k].objectState,
                    reference: payload.activities[k].reference,
                    reportApproveDate: payload.activities[k].reportApproveDate,
                    reportApproved: payload.activities[k].reportApproved,
                    reportNote: payload.activities[k].reportNote,
                    reportWorkDone: payload.activities[k].reportWorkDone,
                    requisitionDate: payload.activities[k].requisitionDate,
                    requisitionId: payload.activities[k].requisitionId,
                    requisitionSerialNumber: payload.activities[k].requisitionSerialNumber,
                    requisitionStatus: payload.activities[k].requisitionStatus,
                    requisitionStatusDate: payload.activities[k].requisitionStatusDate,
                    requisitionStatusId: payload.activities[k].requisitionStatusId,
                    routineActivityId: payload.activities[k].routineActivityId,
                    routineInterval: payload.activities[k].routineInterval,
                    routineIntervalTypeId: payload.activities[k].routineIntervalTypeId,
                    routineNextDate: payload.activities[k].routineNextDate,
                    routineTemplateId: payload.activities[k].routineTemplateId,
                    routineUnitOfTimeTypeId: payload.activities[k].routineUnitOfTimeTypeId,
                    routineDeadlineInterval: payload.activities[k].routineDeadlineInterval,
                    routineDeadlineUnitTypeId: payload.activities[k].routineDeadlineUnitTypeId,
                    sentToOrganization: payload.activities[k].sentToOrganization,
                    sentToOrganizationId: payload.activities[k].sentToOrganizationId,
                    sentToUser: payload.activities[k].sentToUser,
                    sentToUserId: payload.activities[k].sentToUserId,
                    startDate: payload.activities[k].startDate,
                    status: payload.activities[k].status,
                    declined: payload.activities[k].declined,
                    taskId: payload.activities[k].taskId,
                    updated: payload.activities[k].updated,
                    reportReadyForApproval: payload.activities[k].reportReadyForApproval,
                    allObjectsInActivityCount: payload.activities[k].allObjectsInActivityCount
                }
                if (activity.objectList === undefined) {
                    activity.objectList = []
                }
                if (activity.requisitionStatus === undefined) {
                    activity.requisitionStatus = null
                }
                if (activity.objectList && activity.objectList.length && activity.objectList.length > 0) {
                    for (let p in activity.objectList) {
                        activity.objectList[p].deleting = false
                        state.wfsObjects.push(activity.objectList[p])
                    }
                }
                state.selectedTask.activities.unshift(activity)
            }
        }
        // Getting the reports documents
        if (payload.requisitions) {
            state.taskRequisitionDocuments = []
            payload.requisitions.forEach((requisition) => {
                requisition.selected = false
                requisition.isAccordionOpen = false
                state.selectedTask.requisitions.push(requisition)
                if (requisition.report.reportDocumentList) {
                    requisition.report.reportDocumentList.forEach((file) => {
                        if (file.contentType.startsWith('image/')) {
                            axios.downloadDocument('/Report/GetReportThumbnail', {
                                RequisitionId: file.requisitionId,
                                ReportDocumentId: file.reportDocumentId,
                                ThumbnailWidth: 180,
                                ThumbnailHeight: 180,
                                Crop: true
                            })
                                .then((response) => {
                                    let blob = new Blob([response.data], { type: file.contentType })

                                    state.taskRequisitionDocuments.push({
                                        id: file.reportDocumentId,
                                        dateCreated: file.created,
                                        name: file.originalFileName,
                                        contentType: file.contentType,
                                        icon: null,
                                        dataSource: window.URL.createObjectURL(blob),
                                        photoTaken: file.photoTaken,
                                        description: file.description,
                                        origin: {
                                            name: 'requisition',
                                            id: file.requisitionId
                                        },

                                        raw: file
                                    })
                                })
                        } else {
                            state.taskRequisitionDocuments.push({
                                id: file.reportDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: null,
                                photoTaken: file.photoTaken,
                                description: file.description,
                                origin: {
                                    name: 'requisition',
                                    id: file.requisitionId
                                },

                                raw: file
                            })
                        }
                    })
                }
            })
        }
        if (payload.requests.length > 0) {
            state.taskDocumentsFromEnquiry = []
            payload.requests.forEach((request) => {
                state.selectedTask.requests.push(request)
                request.requestDocumentList.forEach((file) => {
                    state.taskDocumentsFromEnquiry.push({
                        id: file.requestDocumentId,
                        dateCreated: file.created,
                        name: file.fileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        origin: {
                            name: 'task',
                            id: payload.task.taskId
                        },

                        raw: file
                    })
                })
            })
        }
        if (payload.logs.length > 0) {
            payload.logs.forEach(log => {
                state.selectedTask.logs.push(log)
            })
        }

        state.selectedRequisitions = state.selectedTask.requisitions
        state.selectedActivities = state.selectedTask.activities
        const selected = Object.assign({}, state.selectedTask)
        state.tempTask = selected
    },
    addWholeTaskTemplateItem: (state, payload) => {
        let task = {
            activities: [],
            businessAreaType: payload.task.businessAreaType,
            businessAreaTypeId: payload.task.businessAreaTypeId,
            closedDate: payload.task.closedDate,
            created: payload.task.created,
            documents: [],
            isTemplate: payload.task.isTemplate,
            name: payload.task.name,
            objectState: payload.task.objectState,
            ownerEmail: payload.task.ownerEmail,
            ownerName: payload.task.ownerName,
            ownerPhoneNumber: payload.task.ownerPhoneNumber,
            ownerUserId: payload.task.ownerUserId,
            taskId: payload.task.taskId,
            taskVersionStamp: payload.task.taskVersionStamp,
            templateCreateRequisition: payload.task.templateCreateRequisition,
            updated: payload.task.updated
        }
        state.selectedTemplate = task
        if (payload.documents.length > 0) {
            if (state.taskDocuments.length > 0) {
                state.taskDocuments = []
            }
            payload.documents.forEach((file) => {
                if (file.contentType.startsWith('image/')) {
                    axios.downloadDocument('/TaskActivity/GetTaskThumbnail', {
                        TaskId: payload.task.taskId,
                        TaskDocumentId: file.taskDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.taskDocuments.push({
                                id: file.taskDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                taskTemplateId: file.taskTemplateId,
                                photoTaken: file.photoTaken,
                                description: file.description,
                                origin: {
                                    name: 'task',
                                    id: payload.task.taskId
                                },
                                requestId: file.requestId,
                                requestDocumentId: file.requestDocumentId,
                                raw: file
                            })
                        })
                } else {
                    state.taskDocuments.push({
                        id: file.taskDocumentId,
                        dateCreated: file.created,
                        name: file.originalFileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        taskTemplateId: file.taskTemplateId,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        origin: {
                            name: 'task',
                            id: payload.task.taskId
                        },
                        requestId: file.requestId,
                        requestDocumentId: file.requestDocumentId,
                        raw: file
                    })
                }
            })
        }
        if (payload.activities.length > 0) {
            for (let k in payload.activities) {
                let activity = {
                    selected: false,
                    isAccordionOpen: true,
                    generatedActivityId: payload.activities[k].generatedActivityId,
                    activityId: payload.activities[k].activityId,
                    activityIdList: payload.activities[k].activityIdList,
                    activityType: payload.activities[k].activityType,
                    activityTypeId: payload.activities[k].activityTypeId,
                    activityVersionStamp: payload.activities[k].activityVersionStamp,
                    created: payload.activities[k].created,
                    description: payload.activities[k].description,
                    generateFromDate: payload.activities[k].generateFromDate,
                    highPriority: payload.activities[k].highPriority,
                    hyperlink: payload.activities[k].hyperlink,
                    isRoutineTemplate: payload.activities[k].isRoutineTemplate,
                    latestDate: payload.activities[k].latestDate,
                    numberOfDays: payload.activities[k].numberOfDays,
                    reference: payload.activities[k].reference,
                    routineActivityId: payload.activities[k].routineActivityId,
                    routineInterval: payload.activities[k].routineInterval,
                    routineIntervalTypeId: payload.activities[k].routineIntervalTypeId,
                    routineNextDate: payload.activities[k].routineNextDate,
                    routineTemplateId: payload.activities[k].routineTemplateId,
                    routineUnitOfTimeTypeId: payload.activities[k].routineUnitOfTimeTypeId,
                    routineDeadlineInterval: payload.activities[k].routineDeadlineInterval,
                    routineDeadlineUnitTypeId: payload.activities[k].routineDeadlineUnitTypeId,
                    sentToOrganization: payload.activities[k].sentToOrganization,
                    sentToOrganizationId: payload.activities[k].sentToOrganizationId,
                    sentToUser: payload.activities[k].sentToUser,
                    sentToUserId: payload.activities[k].sentToUserId,
                    startDate: payload.activities[k].startDate,
                    taskId: payload.activities[k].taskId,
                    updated: payload.activities[k].updated
                }
                state.selectedTemplate.activities.push(activity)
            }
        }
        state.selectedActivities = state.selectedTemplate.activities
        const selected = Object.assign({}, state.selectedTemplate)
        state.tempTask = selected
    },
    // NEW
    updatedActivity: (state, payload) => {
        let foundActivity = null
        state.activitySaved = false
        if (payload.activityId === '') {
            if (payload.generatedActivityId) {
                foundActivity = state.selectedTask.activities.find(a => a.generatedActivityId === payload.generatedActivityId)
                if (foundActivity) {
                    payload.activityId = foundActivity.activityId
                }
            }
        } else {
            foundActivity = state.selectedTask.activities.find(a => a.activityId === payload.activityId)
        }

        let activity = foundActivity
        for (let prop in payload) {
            activity[prop] = payload[prop]
        }
    },
    addSelectedTask: (state, payload) => {
        if (!payload.newTask) {
            // Copy the saved task fields. Activities are not part of the save payload, so keep the loaded ones.
            let key = Object.keys(payload.task)
            let val = Object.values(payload.task)
            for (let i in key) {
                if (key[i] !== 'activities') {
                    state.selectedTask[key[i]] = val[i]
                }
            }
        } else {
            let key = Object.keys(payload.task)
            let val = Object.values(payload.task)
            for (let i in key) {
                state.selectedTask[key[i]] = val[i]
            }
            state.selectedTask.taskId = payload.res.taskId
        }
        state.selectedTask.taskVersionStamp = payload.res.taskVersionStamp
        state.tempTask = state.selectedTask
    },
    addSelectedTemplate: (state, payload) => {
        state.selectedTemplate = payload.data
        state.selectedTemplate.taskId = payload.response.taskId
        state.selectedTemplate.taskVersionStamp = payload.response.taskVersionStamp
        state.tempTask = state.selectedTemplate
    },
    addActivityToSelectedTask: (state, payload) => {
        if (state.isTemplate) {
            state.selectedTemplate.activities.push(payload)
            state.selectedActivities = state.selectedTemplate.activities
        } else {
            state.selectedTask.activities.push(payload)
            state.selectedActivities = state.selectedTask.activities
        }
    },
    addActivityToSelectedTemplate: (state, payload) => {
        state.selectedTemplate.activities.push(payload)
    },
    addActivitiesAndObjectsList: (state, payload) => {
        if (!state.isTemplate) {
            if (state.selectedTask.activities.length > 0) {
                state.selectedTask.activities.push(payload)
            } else {
                for (let i in payload) {
                    state.selectedTask.activities.push(payload[i])
                }
            }
        } else {
            if (state.selectedTemplate.activities.length > 0) {
                Vue.set(state.selectedTemplate.activities, state.selectedTemplate.activities.length, payload)
            } else {
                for (let i in payload) {
                    Vue.set(state.selectedTemplate.activities, i, payload[i])
                }
            }
        }
    },
    addDocumentsFromTemplate: (state, payload) => {
        if (payload) {
            let documents = payload

            documents.forEach(doc => {
                doc.fromTemplate = true
                state.taskDocuments.push({
                    id: doc.taskDocumentId,
                    dateCreated: doc.created,
                    name: doc.originalFileName,
                    fromTemplate: doc.fromTemplate,
                    contentType: doc.contentType,
                    icon: null,
                    dataSource: null,
                    taskTemplateId: doc.taskTemplateId,
                    photoTaken: doc.photoTaken,
                    description: doc.description,
                    origin: {
                        name: 'task',
                        id: state.activeTaskId
                    },
                    requestId: doc.requestId,
                    requestDocumentId: doc.requestDocumentId,
                    raw: doc
                })
            })
        }
    },
    updateActivitiesAndObjectsList: (state, payload) => {
        if (!state.isTemplate) {
            for (let i in state.selectedTask.activities) {
                if (state.selectedTask.activities[i].activityId === payload.activityId) {
                    state.selectedTask.activities[i] = payload
                }
            }
        } else {
            for (let i in state.selectedTemplate.activities) {
                if (state.selectedTemplate.activities[i].activityId === payload.activityId) {
                    state.selectedTemplate.activities[i] = payload
                }
            }
        }
    },
    // NEW
    removeItemFromActivitiesAndObjectsList: (state, payload) => {
        let result = null

        if (state.isTemplate) {
            state.selectedActivities = state.selectedTemplate.activities

            result = state.selectedTemplate.activities.filter((activity) => {
                return !payload.activityIdList.some(id => id === activity.activityId)
            })

            state.selectedTemplate.activities = result
        } else {
            state.selectedActivities = state.selectedTask.activities

            result = state.selectedTask.activities.filter((activity) => {
                return !payload.activityIdList.some(id => id === activity.activityId)
            })

            state.selectedTask.activities = result
        }

        state.selectedActivities = result
    },
    removeItemFromTemplateActivitiesAndObjectsList: (state, payload) => {
        let result = null

        state.selectedActivities = state.selectedTemplate.activities
        result = state.selectedTemplate.activities.filter((activity, index) => {
            if (!activity.activityId) {
                return !payload.activityIdList.some(id => id.startsWith(`${activity.activityTypeId}_${index}`))
            } else {
                return !payload.activityIdList.some(id => id === activity.activityId)
            }
        })
        state.selectedTemplate.activities = result
        state.selectedActivities = result
    },
    removeObjectFromActivity: (state) => {
        for (let i in state.selectedTask.activities) {
            for (let x in state.selectedTask.activities[i].objectList) {
                if (state.selectedTask.activities[i].objectList[x].deleting === true) {
                    state.selectedTask.activities[i].objectList.splice(x, 1)
                }
            }
        }
    },
    addFirmsForActivities: (state, payload) => {
        state.firmsForActivities = payload
    },
    addNewFirmForActivities: (state, payload) => {
        state.firmsForActivities.push(payload)
    },
    addAllUsersInFirmForActivity: (state, payload) => {
        state.usersInFirmForActivity = payload
    },
    addContactsForDashboard: (state, payload) => {
        state.contactsInFirmForActivity = payload
    },
    addOrRemoveSelectedActivity: (state, payload) => {
        // added or removed
    },
    setTaskTemplate: (state, payload) => {
        state.isTemplate = payload
    },
    addTaskTemplateList: (state, payload) => {
        state.taskTemplateList = payload
    },
    taskDocumentAdd: (state, obj) => {
        state.taskDocuments.push(obj)
    },
    updateTaskDocuments: (state, obj) => {
        if (!obj.template && obj.data.length === 1 && obj.data[0].updating) {
            state.taskDocuments.map(stateDoc => obj.data.find(newDoc => newDoc.id === stateDoc.id) || stateDoc)
        } else {
            state.taskDocuments = []
            obj.data.forEach(doc => {
                state.taskDocuments.push({
                    id: doc.id,
                    dateCreated: doc.created,
                    name: doc.name ? doc.name : doc.originalFileName,
                    fromTemplate: doc.fromTemplate,
                    contentType: doc.contentType,
                    icon: null,
                    dataSource: doc.dataSource !== null ? null : doc.dataSource,
                    taskTemplateId: doc.taskId,
                    photoTaken: doc.photoTaken,
                    description: doc.description,
                    origin: {
                        name: 'task',
                        id: state.activeTaskId
                    },
                    requestId: doc.requestId,
                    requestDocumentId: doc.requestDocumentId,
                    raw: doc
                })
            })
        }
    },
    detachTaskDocument: (state, obj) => {
        state.taskDocuments.splice(obj, 1)
    },
    updateSelectedTaskId: (state, id) => {
        state.activeTaskId = id
    },
    updateTaskSelectedLog: (state, payload) => {
        state.selectedTask.logs = payload
    },
    updateTaskSelectedRequisitionsDocumentVersion: (state, payload) => {
        Array.from(state.selectedTask.requisitions).forEach(r => {
            Array.from(r.report.reportDocumentList).forEach(d => {
                if (d.id === payload.id) {
                    d.reportDocumentVersionStamp = payload.reportDocumentVersionStamp
                }
            })
        })
    }
}

const actions = {
    taskDocumentAdd: ({commit, dispatch}, data) => {
        if (state.activeTaskId === '') {
            return commit('taskDocumentAdd', {
                id: null,
                dateCreated: new Date().toISOString(),
                name: data.file.name,
                contentType: data.file.type,
                icon: null,
                dataSource: data.file.type.startsWith('image/') ? window.URL.createObjectURL(data.file) : null,
                photoTaken: data.dataType.includes('image/') ? data.file.lastModifiedDate || new Date(data.file.lastModified) : null,
                description: null,
                origin: {
                    name: 'task',
                    id: state.activeTaskId
                },

                raw: data
            })
        }

        if (data.file) {
            let dateString = data.file.lastModifiedDate || new Date(data.file.lastModified)

            dateString = dateString.toLocaleString('en-GB', { timeZone: 'UTC' })
            dateString = dateString.replace(',', '')

            return axios.uploadDocument('/TaskActivity/AppendTaskDocument', state.activeTaskId, dateString, null, data.data)
                .then((response) => {
                    data.taskDocumentVersionStamp = response.data.taskDocumentVersionStamp
                    commit('taskDocumentAdd', {
                        id: response.data.taskDocumentId,
                        dateCreated: new Date().toISOString(),
                        name: data.file.name,
                        contentType: data.file.type,
                        icon: null,
                        dataSource: data.file.type.startsWith('image/') ? window.URL.createObjectURL(data.file) : null,
                        photoTaken: data.dataType.includes('image/') ? data.file.lastModifiedDate || new Date(data.file.lastModified) : null,
                        description: null,
                        origin: {
                            name: 'task',
                            id: state.activeTaskId
                        },

                        raw: data
                    })
                })
                .catch((error) => {
                    return new Promise((resolve, reject) => {
                        reject(error)
                    })
                })
        }
    },
    taskDocumentRemove: ({commit, dispatch}, id) => {
        return axios.post('/TaskActivity/DeleteTaskDocument', {
            taskId: state.activeTaskId,
            taskDocumentId: id
        })
            .then((response) => {
                return new Promise((resolve, reject) => {
                    const file = state.taskDocuments.find(document => document.id === JSON.parse(response.config.data).taskDocumentId)
                    const index = state.taskDocuments.indexOf(file)

                    if (file.dataSource) {
                        window.URL.revokeObjectURL(file.dataSource)
                    }
                    commit('detachTaskDocument', index)
                    resolve(response, id)
                })
            }, (error) => {
                return new Promise((resolve, reject) => {
                    reject(error)
                })
            })
    },
    taskDocumentOpen: ({commit, dispatch}, payload) => {
        let requestURL = null
        let requestData = {}
        let fileData = payload

        if (typeof payload === 'object' && payload.taskId && payload.file) {
            fileData = payload.file
        }

        if (fileData.origin.name === 'enquiry' && fileData.origin.id) {
            requestURL = '/Request/GetRequestDocumentStream'
            requestData = {
                RequestId: fileData.origin.id,
                RequestDocumentId: fileData.id
            }
        } else if (fileData.origin.name === 'task' && fileData.origin.id) {
            requestURL = '/TaskActivity/GetTaskDocumentStream'
            requestData = {
                TaskId: fileData.origin.id,
                TaskDocumentId: fileData.id
            }
        } else if (fileData.origin.name === 'requisition' && fileData.origin.id) {
            requestURL = '/Report/GetReportDocumentStream'
            requestData = {
                RequisitionId: fileData.origin.id,
                ReportDocumentId: fileData.id
            }
        }

        return axios.downloadDocument(requestURL, requestData)
            .then((response) => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: fileData.contentType })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileData.name)
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')
                    link.href = data
                    link.target = '_blank'
                    link.click()

                    resolve(blob)
                })
            })
    },
    taskDocumentDownload: ({commit, dispatch}, payload) => {
        let requestURL = null
        let requestData = {}
        let fileData = payload

        if (typeof payload === 'object' && payload.file) {
            fileData = payload.file
        }

        if (fileData.origin.name === 'enquiry' && fileData.origin.id) {
            requestURL = '/Request/GetRequestDocumentStream'
            requestData = {
                RequestId: fileData.origin.id,
                RequestDocumentId: fileData.id
            }
        } else if (fileData.origin.name === 'task' && fileData.origin.id) {
            requestURL = '/TaskActivity/GetTaskDocumentStream'
            requestData = {
                TaskId: fileData.origin.id,
                TaskDocumentId: fileData.id
            }
        } else if (fileData.origin.name === 'requisition' && fileData.origin.id) {
            requestURL = '/Report/GetReportDocumentStream'
            requestData = {
                RequisitionId: fileData.origin.id,
                ReportDocumentId: fileData.id
            }
        }

        return axios.downloadDocument(requestURL, requestData)
            .then((response) => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: fileData.contentType })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileData.name)
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')
                    link.href = data
                    if (fileData.photoTaken !== null) {
                        let ext = fileData.name.split('.').pop()
                        let fileName = window['moment'].utc(fileData.photoTaken).local().format('YYYYMMDD[_]HHmm')

                        if (fileName !== null & ext !== null) {
                            link.download = fileName.concat('.', ext)
                        } else {
                            link.download = fileData.name
                        }
                    } else {
                        link.download = fileData.name
                    }
                    link.click()

                    resolve(blob)
                })
            })
    },
    taskDocumentDescriptionUpdate: ({ commit, dispatch }, file) => {
        axios.post('/TaskActivity/SetTaskDocumentDescription', {
            taskId: state.activeTaskId,
            taskDocumentId: file.id,
            taskDocumentVersionStamp: file.raw.taskDocumentVersionStamp,
            description: file.description
        })
            .then((response) => {
                file.raw.taskDocumentVersionStamp = response.data.taskDocumentVersionStamp
                commit('updateTaskDocuments', { data: [file] })
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },

    setRequestOnTaskList: ({ commit }, taskId) => {
        return axios.post('TaskActivity/getRequestOnTaskList', {taskId: taskId})
            .then((response) => {
                commit('addRequestOnTaskList', response.data)
            })
            .catch((error) => {
                commit('errorHandler', error)
            })
    },
    setRequestOnTaskListFromEnquiry: ({ commit }, enquiry) => {
        commit('addRequestOnTaskList', enquiry)
    },
    setRemoveRequestOnTaskListFromEnquiry: ({ commit }, enquiry) => {
        commit('setRemoveRequestOnTaskListFromEnquiry', enquiry)
    },
    // copyDocumentToTask: ({commit, dispatch}, data) => {
    //     return commit('copyDocumentToTask', data)
    // },
    setEnquiryAddressToTask: ({ commit, dispatch }, addressObj) => {
        commit('setEnquiryAddressToTask', addressObj)
    },
    async setTaskObjectList ({ commit, dispatch }, data) {
        try {
            let res = {}
            let response = null
            if (data.bBox) {
                response = await axios.post('/TaskActivity/GetWholeTaskItem', {taskId: data.id, bBox: data.bBox})
            } else {
                response = await axios.post('/TaskActivity/GetWholeTaskItem', {taskId: data})
            }

            let task = {objectState: 0}
            let activities = []
            let requisitions = []

            // get taskItem
            for (let t in response.data.taskItem) {
                task[t] = response.data.taskItem[t]
            }

            // get activityList
            if (response.data.activitiesList) {
                response.data.activitiesList.forEach(act => {
                    if (act.activityId) {
                        act.generatedActivityId = act.activityId
                    }
                    activities.push(act)
                })
            }

            // get requisitionList
            if (response.data.requisitionList) {
                state.selectedTask.requisitions.forEach((requisition) => {
                    if (response.data.requisitionList.find(responseRequisition => responseRequisition.requisitionId === requisition.requisitionId)) {
                        requisition.report.objectList = response.data.requisitionList.find(responseRequisition => responseRequisition.requisitionId === requisition.requisitionId).report.objectList
                    }
                })
            }

            res.task = task
            res.activities = activities
            res.requisitions = requisitions
            commit('addTaskObjects', res)
        } catch (err) {
            commit('errorHandler', err)
            throw err
        }
    },
    async getWholeTaskItem ({ commit, dispatch }, data) {
        try {
            let res = {}
            let response = null

            if (data.id) {
                response = await axios.post('/TaskActivity/GetWholeTaskItem', {taskId: data.id, bBox: data.bBox})
            } else {
                response = await axios.post('/TaskActivity/GetWholeTaskItem', {taskId: data})
            }

            let task = {
                objectState: 0
            }
            let documents = []
            let logs = []
            let activities = []
            let requisitions = []
            let requests = []

            // get taskItem
            for (let t in response.data.taskItem) {
                task[t] = response.data.taskItem[t]
            }

            // get documents
            if (response.data.taskDocumentList) {
                response.data.taskDocumentList.forEach(doc => {
                    documents.push(doc)
                })
            }

            // get logs
            if (response.data.taskLogList) {
                response.data.taskLogList.forEach(log => {
                    logs.push(log)
                })
            }

            // get activityList
            if (response.data.activitiesList) {
                response.data.activitiesList.forEach(act => {
                    if (act.activityId) {
                        act.generatedActivityId = act.activityId
                    }
                    activities.push(act)
                })
            }

            // get requisitionList
            if (response.data.requisitionList) {
                response.data.requisitionList.forEach(req => {
                    req.declined = null
                    requisitions.push(req)
                })
            }

            if (response.data.requestsList) {
                response.data.requestsList.forEach(request => {
                    requests.push(request)
                })
            }

            res.task = task
            res.documents = documents
            res.logs = logs
            res.activities = activities
            res.requisitions = requisitions
            res.requests = requests
            commit('addWholeTaskItem', res)
        } catch (err) {
            commit('errorHandler', err)
            throw err
        }
    },
    getWholeTaskTemplateItem: ({ commit, dispatch }, id) => {
        let res = {}
        return axios.post('/TaskActivity/GetWholeTaskItem', {taskId: id}).then((response) => {
            let task = {objectState: 0}
            let documents = []
            let activities = []

            // get taskItem
            for (let t in response.data.taskItem) {
                task[t] = response.data.taskItem[t]
            }

            // get documents
            if (response.data.taskDocumentList) {
                response.data.taskDocumentList.forEach(doc => {
                    documents.push(doc)
                })
            }

            // get activityList
            if (response.data.activitiesList) {
                response.data.activitiesList.forEach(act => {
                    activities.push(act)
                })
            }

            res.task = task
            res.documents = documents
            res.activities = activities
            commit('addWholeTaskTemplateItem', res)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    // NEW
    async addActivityObjects ({ commit }, payload) {
        await axios.post('/TaskActivity/AddVectorObjectsToActivities', payload).catch(err => commit('errorHandler', err))
    },
    // NEW
    async addActivityObjectsByFilter ({ commit }, payload) {
        await axios.post('/TaskActivity/AddVectorObjectsToActivitiesByFilter', payload).catch(err => commit('errorHandler', err))
    },
    // NEW
    async deleteActivityObjects ({ commit }, payload) {
        await axios.post('/TaskActivity/RemoveObjectsFromActivities', payload).catch(err => commit('errorHandler', err))
    },
    // NEW
    async deleteActivities ({ commit }, payload) {
        await axios.post('/TaskActivity/DeleteActivities', payload).catch(err => commit('errorHandler', err))
        commit('removeItemFromActivitiesAndObjectsList', payload)
    },
    deleteTemplateActivities ({ commit }, payload) {
        const activitiesSaved = payload.activityList.filter(activity => activity.activityId).map(activity => activity.activityId)
        const activitiesNew = payload.activityList.filter(activity => activity.generatedActivityId).map(activity => activity.generatedActivityId)

        if (activitiesSaved.length > 0) {
            const requestData = {
                taskId: payload.templateId,
                activityIdList: activitiesSaved
            }

            axios.post('/TaskActivity/DeleteActivities', requestData)
                .then((response) => {
                    commit('removeItemFromTemplateActivitiesAndObjectsList', {
                        taskId: payload.templateId,
                        activityIdList: activitiesSaved
                    })
                })
                .catch(error => commit('errorHandler', error))
        }
        if (activitiesNew.length > 0) {
            commit('removeItemFromTemplateActivitiesAndObjectsList', {
                taskId: payload.templateId,
                activityIdList: activitiesNew
            })
        }
    },
    // NEW
    async updateActivity ({ commit }, payload) {
        await axios.post('/TaskActivity/createUpdateActivity', payload).then((response) => {
            // New Timestamp
            const res = {...payload, activityVersionStamp: response.data.activityVersionStamp}
            commit('updatedActivity', res)
        }).catch(err => commit('errorHandler', err))
    },
    // NEW
    async createNewActivity ({ commit }, payload) {
        await axios.post('/TaskActivity/createUpdateActivity', payload).then((response) => {
            const activity = {
                activityId: response.data.activityId, // New data
                activityVersionStamp: response.data.activityVersionStamp, // New data
                orderTask: payload.orderTask,
                sentToOrganization: payload.sentToOrganization,
                sentToOrganizationId: payload.sentToOrganizationId,
                sentToUser: payload.sentToUser,
                sentToUserId: payload.sentToUserId,
                activityTypeId: payload.activityTypeId,
                activityType: payload.activityType,
                reference: payload.reference,
                hyperlink: payload.hyperlink,
                description: payload.description,
                taskId: payload.taskId,
                objectList: payload.objectList ? payload.objectList : [],
                generatedActivityId: payload.generatedActivityId,
                requisitionStatus: null,
                selected: false,
                isAccordionOpen: false,
                allObjectsInActivityCount: 0,
                startDate: payload.startDate,
                latestDate: payload.latestDate,
                status: 'Ikke rekvireret'
            }
            commit('addActivityToSelectedTask', activity)
        }).catch(err => commit('errorHandler', err))
    },
    // NEW
    async updateTask ({ commit }, payload) {
        // Prepare data for API
        const task = {
            taskId: payload.taskId,
            taskVersionStamp: payload.taskVersionStamp,
            locationPointWkt: payload.locationPointWkt,
            activities: [],
            addressGuid: payload.addressGuid,
            businessAreaTypeId: payload.businessAreaTypeId,
            address1: payload.address1,
            address2: payload.address2,
            city: payload.city,
            name: payload.name,
            ownerUserId: payload.ownerUserId,
            postalCode: payload.postalCode
        }

        // Call API
        await axios.post('/TaskActivity/CreateUpdateTask', task).then((response) => {
            const res = response.data
            commit('addSelectedTask', { res, newTask: false, task: task })
        }).catch(err => {
            commit('errorHandler', err)
            // Rethrow so the page can tell the user the task was not saved
            throw err
        })
        // State change
    },
    // NEW
    async createNewTask ({ commit }, payload) {
        // Prepare data for API
        const task = {
            locationPointWkt: payload.locationPointWkt,
            activities: [],
            addressGuid: payload.addressGuid,
            businessAreaTypeId: payload.businessAreaTypeId,
            address1: payload.address1,
            address2: payload.address2,
            city: payload.city,
            name: payload.name,
            ownerUserId: payload.ownerUserId,
            postalCode: payload.postalCode
        }

        // Call API
        await axios.post('/TaskActivity/CreateUpdateTask', task).then((response) => {
            const res = response.data
            commit('addSelectedTask', { res, newTask: true, task: task })
        }).catch(err => commit('errorHandler', err))
    },
    // NEW
    async createTaskRequisition ({ commit }, payload) {
        await axios.post('/Requisition/CreateRequisitions', payload).catch(err => commit('errorHandler', err))
    },
    // NEW
    async copyTaskDocuments ({ commit }, payload) {
        await axios.post('/TaskActivity/CopyTaskDocuments', payload)
            .catch(error => commit('errorHandler', error))
        await axios.post('/TaskActivity/GetTaskDocumentList', { taskId: payload.toTaskId })
            .then((response) => {
                commit('updateTaskDocuments', { data: response.data, template: true })
            })
            .catch(error => commit('errorHandler', error))
    },
    // NEW
    async copyTemplateActivities ({ commit }, payload) {
        return axios.post('/TaskActivity/GetActivitiesAndObjectsList', { TaskId: payload })
            .then((response) => {
                return response.data.activityList
            })
            .catch(error => commit('errorHandler', error))
    },
    createUpdateTaskTemplate: ({ commit, dispatch }, data) => {
        return axios.post('/TaskActivity/CreateUpdateTaskTemplate', data)
            .then((response) => {
                return new Promise((resolve, reject) => {
                    commit('addSelectedTemplate', {response: response.data, data: data})
                    resolve(response.data)
                })
            }, (error) => {
                commit('errorHandler', error)
            })
            .then((responseTemplate) => {
                let promiseData = {taskId: responseTemplate.taskId}
                return new Promise((resolve, reject) => {
                    let index = 0
                    let activities = []
                    if (state.selectedTemplate.activities && state.selectedTemplate.activities.length > 0) {
                        state.selectedTemplate.activities.forEach((act, idx) => {
                            activities.push(new Promise((resolve, reject) => {
                                let data = act
                                data.taskId = responseTemplate.taskId
                                data.orderTask = idx
                                axios.post('/TaskActivity/CreateUpdateActivityTemplate', data).then((response) => {
                                    state.selectedTemplate.activities[index].activityId = response.data.activityId
                                    state.selectedTemplate.activities[index].taskId = responseTemplate.taskId
                                    state.selectedTemplate.activities[index].activityVersionStamp = response.data.activityVersionStamp
                                    index++
                                    resolve()
                                }).catch(err => reject(err))
                            }))
                        })
                        state.activitySaved = true
                        return Promise.all(activities).then(response => resolve(promiseData))
                    } else {
                        return resolve(promiseData)
                    }
                })
            })
            .then(promiseData => {
                if (state.removeActivities.length > 0) {
                    let objectList = {
                        taskId: promiseData.taskId,
                        activityIdList: []
                    }
                    for (let i in state.removeActivities) {
                        objectList.activityIdList.push(state.removeActivities[i])
                    }
                    return axios.post('/TaskActivity/DeleteActivities', objectList).then(() => {
                        state.removeActivities = []
                        state.activitySaved = true
                    })
                }
                state.activitySaved = true
                state.selectedActivities = state.selectedTemplate.activities
                return promiseData
            })
            .then(promiseData => {
                const documentPromises = state.taskDocuments.map((document) => {
                    return new Promise((resolve, reject) => {
                        if (document.id === null) {
                            let dateString = document.photoTaken

                            if (!dateString && document.raw.file) {
                                dateString = document.raw.file.lastModifiedDate || new Date(document.raw.file.lastModified)
                                dateString = dateString.toLocaleString('en-GB', { timeZone: 'UTC' })
                                dateString = dateString.replace(',', '')
                            }

                            axios.uploadDocument('/TaskActivity/AppendTaskDocument', promiseData.taskId, dateString, document.description, document.raw.data)
                                .then((response) => {
                                    const fileObject = {
                                        id: response.data.taskDocumentId,
                                        dateCreated: new Date().toISOString(),
                                        name: document.raw.file.name,
                                        contentType: document.raw.file.type,
                                        icon: document.icon,
                                        dataSource: document.dataSource,
                                        photoTaken: dateString,
                                        description: document.description,
                                        origin: {
                                            name: 'task',
                                            id: promiseData.taskId
                                        },

                                        raw: document
                                    }
                                    commit('taskDocumentAdd', fileObject)
                                    resolve(fileObject)
                                })
                                .catch((error) => {
                                    reject(error)
                                })
                        } else if (document.updating) {
                            commit('taskDocumentDescriptionUpdate', document)
                        } else {
                            resolve(document)
                        }
                    })
                })

                Promise.all(documentPromises)
                    .then((documents) => {
                        documents = documents.filter(d => d.id !== null)
                        state.taskDocuments = documents
                    })
                    .catch((error) => {
                        commit('errorHandler', error)
                        throw error
                    })
            })
    },
    // close task
    setTaskStatusClose: ({ commit }, object) => {
        return axios.post('/TaskActivity/SetTaskStatusClose', object).then((response) => {
            commit('successHandler', response.status)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    // open task
    setTaskStatusOpen: ({ commit }, object) => {
        return axios.post('/TaskActivity/SetTaskStatusOpen', object).then((response) => {
            commit('successHandler', response.status)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    // delete task
    deleteTaskAndActivities: ({ commit }, taskId) => {
        return axios.post('/TaskActivity/DeleteTaskAndActivities', {taskId: taskId}).then((response) => {
            commit('successHandler', response.status)
            return response
        }, (error) => {
            commit('errorHandler', error)
        })
    },
    setTaskTemplate: ({ commit }, isTemplate) => {
        commit('setTaskTemplate', isTemplate)
    },
    // Activities
    createUpdateActivityTemplate: ({ commit, dispatch }, payload) => {
        state.activitySaved = false
        commit('setTaskTemplate', true)
        let p = {
            activityId: payload.activityId,
            activityType: payload.activityType,
            activityTypeId: payload.activityTypeId,
            description: payload.description,
            hyperlink: payload.hyperlink,
            latestDate: payload.latestDate,
            objectList: payload.objectList,
            reference: payload.reference,
            selected: false,
            isAccordionOpen: false,
            generatedActivityId: payload.generatedActivityId,
            sentToOrganization: payload.sentToOrganization,
            sentToOrganizationId: payload.sentToOrganizationId,
            sentToUser: payload.sentToUser,
            sentToUserId: payload.sentToUserId,
            startDate: payload.startDate,
            taskId: payload.taskId,
            requisitionStatus: null,
            routineInterval: payload.routineInterval,
            routineUnitOfTimeTypeId: payload.routineUnitOfTimeTypeId,
            routineIntervalTypeId: payload.routineIntervalTypeId,
            routineDeadlineInterval: payload.routineDeadlineInterval,
            routineDeadlineUnitTypeId: payload.routineDeadlineUnitTypeId,
            routineNextDate: payload.routineNextDate,
            isRoutineTemplate: payload.isRoutineTemplate
        }
        commit('addActivityToSelectedTemplate', p)
    },
    addActivityToSelectedTask: ({ commit, dispatch }, payload) => {
        let p = {
            sentToOrganization: payload.sentToOrganization,
            sentToUser: payload.sentToUser,
            sentToOrganizationId: payload.sentToOrganizationId,
            activityTypeId: payload.activityTypeId,
            activityType: payload.activityType,
            activityId: payload.activityId,
            reference: payload.reference,
            hyperlink: payload.hyperlink,
            description: payload.description,
            taskId: payload.taskId,
            objectList: payload.objectList,
            requisitionStatus: null,
            selected: false,
            isAccordionOpen: false,
            generatedActivityId: payload.generatedActivityId
        }
        commit('addActivityToSelectedTask', p)
    },
    addActivityToSelectedTemplate: ({ commit, dispatch }, payload) => {
        commit('addActivityToSelectedTemplate', payload)
    },
    updateActivitiesAndObjectsList: ({ commit, dispatch }, payload) => {
        commit('updateActivitiesAndObjectsList', payload)
    },
    updateActivityTemplate: ({ commit, dispatch }, payload) => {
        state.activitySaved = false
        let foundActivity = null
        if (payload.activityId === '') {
            if (payload.generatedActivityId) {
                foundActivity = state.selectedTemplate.activities.find(a => a.generatedActivityId === payload.generatedActivityId)
                if (foundActivity) {
                    payload.activityId = foundActivity.activityId
                }
            }
        } else {
            foundActivity = state.selectedTemplate.activities.find(a => a.activityId === payload.activityId)
        }

        let activity = foundActivity
        for (let prop in payload) {
            activity[prop] = payload[prop]
        }
    },
    getAssociatedOrganizationList: ({ commit, rootState }, data) => {
        let userGroup = ['contractor']
        let supplyTypes = []
        if (data && data.supplyType && Object.keys(rootState.global.selectedSupplyType).length > 0) {
            supplyTypes = [data.supplyType]
        } else {
            supplyTypes = rootState.global.allLists.sysBusinessAreaTypeList
        }
        if (supplyTypes) {
            supplyTypes.forEach(fa => {
                userGroup.push('caseOwner_' + fa.systemName)
                userGroup.push('trustedContractor_' + fa.systemName)
            })
        }

        return axios.post('/Portal/GetAssociatedOrganizationListFilteredByDriveUser', {userGroupSystemNameFilterGroupList: userGroup, selectedOrganizationId: rootState.global.selectedOrganizationId}).then((response) => {
            commit('addFirmsForActivities', response.data)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    getAssociatedOrganizationUserList: ({ commit, dispatch, rootState }, data) => {
        let userGroup = ['contractor']
        let supplyTypes = []
        if (data && data.supplyType && Object.keys(rootState.global.selectedSupplyType).length > 0) {
            if (data.supplyType.length && data.supplyType[0].systemName) {
                supplyTypes = data.supplyType
            } else {
                supplyTypes = rootState.global.allLists.sysBusinessAreaTypeList.filter(supplyType => data.supplyType.includes(supplyType.sysBusinessAreaTypeId))
            }
        } else {
            supplyTypes = rootState.global.allLists.sysBusinessAreaTypeList
        }
        if (supplyTypes) {
            supplyTypes.forEach(fa => {
                userGroup.push('caseOwner_' + fa.systemName)
                userGroup.push('trustedContractor_' + fa.systemName)
            })
        }
        return axios.post('/Account/GetAssociatedOrganizationUserList',
            {
                organizationUsersId: data.firmaId ? data.firmaId : undefined,
                userGroupSystemNameFilterGroupList: userGroup,
                initialOrganization: data.initialOrganization
            }).then((response) => {
            commit('addAllUsersInFirmForActivity', response.data)
            return response.data
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    callBackActivities: ({ commit, dispatch }, payload) => {
        state.activitySaved = false
        // skal fixes
    },
    async getTaskTemplateList ({ dispatch, commit }) {
        await axios.post('/TaskActivity/GetTaskTemplateList', {})
            .then((response) => {
                commit('addTaskTemplateList', response.data)
            })
            .catch(error => commit('errorHandler', error))
    },
    async getActivitiesFromTemplate ({ dispatch, commit }, data) {
        await axios.post('/TaskActivity/GetActivitiesAndObjectsList', {
            TaskId: data.templateId
        })
            .then((response) => {
                if (response.data.activityList.length > 0) {
                    response.data.activityList.forEach(a => {
                        const payload = {
                            orderTask: a.orderTask,
                            activityType: a.activityType,
                            activityTypeId: a.activityTypeId,
                            description: a.description,
                            hyperlink: a.hyperlink,
                            reference: a.reference,
                            sentToOrganization: a.sentToOrganization,
                            sentToOrganizationId: a.sentToOrganizationId,
                            sentToUser: a.sentToUser,
                            sentToUserId: a.sentToUserId,
                            taskId: data.taskId
                        }
                        dispatch('createNewActivity', payload)
                    })
                }

                dispatch('copyTaskDocuments', { fromTaskId: data.templateId, toTaskId: data.taskId })
            })
            .catch(error => commit('errorHandler', error))
    },
    addActivityToOjectList: ({ dispatch, commit }, activity) => {
        commit('addActivitiesAndObjectsList', activity)
    },
    setSelectedActivities: ({ dispatch, commit }, selectedActivity) => {
        commit('addOrRemoveSelectedActivity', selectedActivity)
    },
    getReportOnTaskList: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            if (state.selectedTask.requisitions && state.selectedTask.requisitions.length > 0) {
                let requisitions = []
                state.selectedTask.requisitions.forEach(req => {
                    requisitions.push(new Promise((resolve, reject) => {
                        let data = req
                        axios.post('/Report/GetWholeReportItem', {requisitionId: data.requisitionId}).then((response) => {
                            req.reportObject = []
                            req.reportObject.push(response.data)
                            resolve()
                        }).then(response => {
                        }).catch(err => reject(err))
                    }))
                })
                return Promise.all(requisitions).then(response => resolve())
            } else {
                return resolve()
            }
        })
    },
    async setReportCallBack ({ commit, dispatch }) {
        try {
            if (state.selectedTask.requisitions && state.selectedTask.requisitions.length > 0) {
                let requisitions = []
                state.selectedTask.requisitions.forEach(req => {
                    if (req.selected) {
                        if (req.status === 'Ny' || req.status === 'Accepteret') {
                            requisitions.push(new Promise((resolve, reject) => {
                                let data = {
                                    requisitionId: req.requisitionId,
                                    requisitionStatusId: '470d0fb8-bcab-4799-9d33-954e5cbc8b34',
                                    requisitionVersionStamp: req.requisitionVersionStamp,
                                    logText: 'Kaldt tilbage'
                                }
                                axios.post('/Requisition/SetRequisitionStatus', data).then((response) => {
                                    req.requisitionVersionStamp = response.data.requisitionVersionStamp
                                    req.statusId = '470d0fb8-bcab-4799-9d33-954e5cbc8b34'
                                    req.status = 'Kaldt tilbage'
                                    req.declined = false

                                    state.selectedTask.activities.forEach(act => {
                                        if (act.requisitionId === req.requisitionId) {
                                            act.requisitionStatusId = '470d0fb8-bcab-4799-9d33-954e5cbc8b34'
                                            act.requisitionStatus = 'Kaldt tilbage'
                                            act.status = 'Kaldt tilbage'
                                            act.declined = false
                                        }
                                    })
                                }).catch(err => reject(err))
                            }))
                        }
                    }
                })
            }
        } catch (err) {
            throw err
        }
    },
    async setReportApproved ({ dispatch, commit }, approved) {
        try {
            if (state.selectedTask.requisitions && state.selectedTask.requisitions.length > 0) {
                let requisitions = []
                state.selectedTask.requisitions.forEach(req => {
                    if (req.selected) {
                        if ((approved && req.status === 'Færdigmeldt') || (!approved && (req.status === 'Færdigmeldt' || req.status === 'Godkendt'))) {
                            requisitions.push(new Promise((resolve, reject) => {
                                let data = {
                                    requisitionId: req.requisitionId,
                                    approved: approved,
                                    note: '',
                                    reportVersionStamp: req.report.report.reportVersionStamp
                                }
                                axios.post('/Report/SetReportApproved', data).then((response) => {
                                    req.report.report.reportVersionStamp = response.data.reportVersionStamp
                                    req.report.report.approveDate = response.data.approveDate
                                    req.report.report.readyForApproval = response.data.readyForApproval

                                    // find activity and update status
                                    state.selectedTask.activities.forEach(act => {
                                        if (act.requisitionId === req.requisitionId) {
                                            act.reportApproveDate = response.data.approveDate
                                            if (!approved) {
                                                act.declined = true
                                                act.status = 'Accepteret'
                                                act.reportReadyForApproval = false
                                            } else {
                                                act.declined = false
                                                act.status = 'Godkendt'
                                            }
                                        }
                                    })

                                    if (!approved) {
                                        req.declined = true
                                        req.status = 'Accepteret'
                                    } else {
                                        req.declined = false
                                        req.status = 'Godkendt'
                                    }
                                }).catch(err => reject(err))
                            }))
                        } else {
                            let text = approved ? 'Kan kun godkende entreprenøropgaver med statusen "Færdigmeldt".' : 'Kan kun afvise entreprenøropgaver med statusen "Færdigmeldt" eller "Godkendt".'
                            Vue.prototype.$notify({
                                group: 'info',
                                type: 'warn',
                                title: '',
                                text: text
                            })
                        }
                    }
                })
                const response = await Promise.all(requisitions)
                commit('updateActivitiesStatus', response)
                return response
            }
        } catch (err) {
            throw err
        }
    },
    changeSelectedActivityList: ({ dispatch, commit }, boolean) => {
        if (boolean) {
            state.selectedTemplate.activities = state.selectedTask.activities
            state.selectedActivities = state.selectedTemplate.activities
        } else {
            state.selectedTask.activities = state.selectedTemplate.activities
            state.selectedActivities = state.selectedTask.activities
        }
    },
    // Set note til task
    setTaskNote: ({ commit }, comment) => {
        return axios.post('/TaskActivity/CreateUpdateTaskLog', comment).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv at tilføje noten igen'})
            return response
        })
    },
    // Slet note til enquiry
    deleteTaskNote: ({ commit }, comment) => {
        let commentObj = {
            'taskId': comment.taskId,
            'taskLogId': comment.taskLogId
        }
        return axios.post('/TaskActivity/DeleteTaskLog', commentObj).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv at slette noten igen'})
            return response
        })
    },
    setTaskLogList: ({ commit }, taskId) => {
        return axios.post('/TaskActivity/GetTaskLogList', {taskId: taskId}).then((response) => {
            commit('updateTaskSelectedLog', response.data)
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            return response
        })
    },
    clearSelectedTask: ({ commit }) => {
        state.selectedTask = {name: null, logs: [], activities: [], requisitions: [], requests: []}
    },
    clearTaskDocuments: ({ commit }) => {
        state.taskDocuments = []
    },
    async printCaseHistoryTask ({ commit }, id) {
        try {
            if (!id) {
                id = state.activeTaskId
            }
            const response = await axios.downloadDocument('/TaskActivity/GetTaskCaseReportStream', {taskId: id})
            return new Promise((resolve, reject) => {
                let blob = new Blob([response.data], { type: 'application/pdf' })

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, 'sagsforløb_opgave')
                    resolve(blob)
                }

                const data = window.URL.createObjectURL(blob)
                var link = document.createElement('a')
                link.href = data
                link.download = 'sagsforløb_opgave'
                link.click()

                resolve(blob)
            })
        } catch (err) {
            throw err
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/task/task.js